import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from 'theme/tokens';

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box>
      <Typography
        variant='h4'
        sx={{
          color: colors.base.black,
          fontWeight: 600,
        }}
      >
        {title}
      </Typography>
      <Typography variant='body1'
        sx={{color: colors.neutral[500]}}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;